export interface ReviewerStats {
    groupIds: number[];
    isReviewer: boolean;
}

export const DefaultReviewerStats: ReviewerStats = {
    groupIds: [],
    isReviewer: false,
};



// WEBPACK FOOTER //
// ./src/models/abstract/ReviewerStats.ts